module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d3-chart heat-map"
  }, [(!_vm.isDataLoaded) ? _c('loader', {
    staticClass: "panel-loader"
  }) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && !_vm.hasError) ? _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "chart-controls"
  }, [_c('div', {
    staticClass: "scale-container"
  }, [_c('div', {
    staticClass: "scale"
  }, [_c('span', {
    style: ({
      background: _vm.colors.start.color
    })
  }, [_vm._v(_vm._s(_vm.startLabel))]), _vm._v(" "), _c('span', {
    style: ({
      width: '3em',
      background: 'linear-gradient(to right, ' + _vm.colors.start.color + ', ' + _vm.colors.mid.color + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    style: ({
      background: _vm.colors.mid.color
    })
  }, [_vm._v(_vm._s(_vm.midLabel))]), _vm._v(" "), _c('span', {
    style: ({
      width: '3em',
      background: 'linear-gradient(to right, ' + _vm.colors.mid.color + ', ' + _vm.colors.end.color + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    style: ({
      background: _vm.colors.end.color
    })
  }, [_vm._v(_vm._s(_vm.endLabel))])])]), _vm._v(" "), (_vm.hasFilter) ? _c('div', {
    staticClass: "filter"
  }, [_vm._l((_vm.filter), function(filterValue, filterName) {
    return [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[filterName]),
        expression: "filter[filterName]"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filter, filterName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.getData()
        }]
      }
    }, _vm._l((_vm.filterOptions[filterName]), function(filterOption) {
      return _c('option', {
        domProps: {
          "value": filterOption.value
        }
      }, [_vm._v(_vm._s(filterOption.label))])
    }))]
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "chartContainer",
    staticClass: "chart heat-map-container"
  }, [(_vm.hasLegend) ? _c('div', {
    staticClass: "heat-map-legend"
  }, [_c('h4', [_vm._v(_vm._s(_vm.legend['title']))]), _vm._v(" "), _c('dl', [_vm._l((_vm.legend['details']), function(detail) {
    return [_c('dt', [_vm._v(_vm._s(detail.label))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(detail.value))])]
  })], 2)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && _vm.hasError) ? _c('div', {
    staticClass: "error-container alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && _vm.hasGenDate) ? _c('div', {
    staticClass: "chart-generation-date"
  }, [_vm._v("\n        Data generated at: " + _vm._s(_vm.content['genDate']) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab439ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/HeatMap.vue
// module id = 1082
// module chunks = 0